// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"b09822fa845598d9988c","264":"8e8bc9d5c8bf67b377fc","265":"fe4fe3d64a50ea1b1858","318":"579698a8751e5e788a0d"}[chunkId] + ".chunk.js";
};